import { render, staticRenderFns } from "./createFile.vue?vue&type=template&id=f38bb8a8&scoped=true&"
import script from "./createFile.vue?vue&type=script&lang=js&"
export * from "./createFile.vue?vue&type=script&lang=js&"
import style0 from "./createFile.vue?vue&type=style&index=0&id=f38bb8a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f38bb8a8",
  null
  
)

export default component.exports